const Website = () => import("../views/website/website.vue")

export default[
    {
        path:'/website',
        name:'website',
        component:Website,
        meta:{
            keepAlive: true
        }
    }
]